import { MILESTONES } from '@/mocks/schedule';
import { daysUntil, formatCnDate } from '@/utils/date';

const KIND_META: Record<string, { label: string; icon: string; cls: string }> = {
  deadline: { label: '截稿', icon: 'ri-timer-flash-line', cls: 'bg-primary-100 text-primary-700' },
  vote: { label: '开投', icon: 'ri-checkbox-multiple-line', cls: 'bg-accent-100 text-accent-800' },
  result: { label: '出结果', icon: 'ri-award-line', cls: 'bg-secondary-100 text-secondary-800' },
  event: { label: '现场', icon: 'ri-live-line', cls: 'bg-secondary-100 text-secondary-800' },
};

export default function MilestoneTable() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100" aria-labelledby="milestone-table-heading">
      <div className="max-w-6xl mx-auto">
        <h2 id="milestone-table-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          关键节点一览
        </h2>
        <p className="mt-3 text-sm text-foreground-600 max-w-2xl">
          六个必须记住的时间点。截稿与开投用不同标记区分，最急的节点排在上面。
        </p>

        <div className="mt-8 rounded-lg border border-background-200 overflow-hidden">
          <div className="hidden md:grid grid-cols-12 gap-4 bg-background-200 px-6 py-3 text-xs font-medium text-foreground-600">
            <span className="col-span-3">日期</span>
            <span className="col-span-3">节点类型</span>
            <span className="col-span-6">说明</span>
          </div>
          <ul className="divide-y divide-background-200 bg-background-50">
            {MILESTONES.map((m) => {
              const meta = KIND_META[m.kind];
              const left = daysUntil(m.date);
              return (
                <li key={m.date} className="grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-4 px-6 py-5 items-center">
                  <div className="md:col-span-3 flex items-center gap-3">
                    <span className="font-heading text-lg font-bold text-foreground-950">{formatCnDate(m.date)}</span>
                    <span className="text-xs text-foreground-400 md:hidden">
                      {left > 0 ? `还有 ${left} 天` : '已结束'}
                    </span>
                  </div>
                  <div className="md:col-span-3">
                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-medium ${meta.cls}`}>
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className={meta.icon}></i>
                      </span>
                      {meta.label}
                    </span>
                  </div>
                  <div className="md:col-span-6">
                    <h3 className="text-sm md:text-base font-medium text-foreground-950">{m.title}</h3>
                    <p className="mt-1 text-xs md:text-sm text-foreground-500">{m.detail}</p>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}